export default __webpack_public_path__ + "static/media/tree_root_home.653f1e9b.svg";